<template>
       <div class="toggle"
            :class="isOpen ? 'is-active' : ''"
            v-click-outside="hideHandler">
           <a href="" class="toggle__box" @click.prevent="toggleHandler">

               <svg width="24" height="24" viewBox="0 0 24 24" focusable="false" role="presentation">
                   <g class="toggle__points">
                       <circle cx="7" cy="12" r="1.55"></circle>
                       <circle cx="12" cy="12" r="1.55"></circle>
                       <circle cx="17" cy="12" r="1.55"></circle>
                   </g>
               </svg>


           </a>

           <transition name="dropdown" mode="in-out">
               <div class="toggle__list" v-if="isOpen">
                   <div class="toggle__list-item"
                        v-for="(item,idx) in buttonsList"
                        :key="idx"
                        @click="showModal(item.type)"
                   >
                       {{item.title}}
                   </div>
               </div>
           </transition>
       </div>

</template>

<script>
    import ClickOutside from 'vue-click-outside';
    import {isUndefined} from '@/helpers/helpers'
    export default {
        props: ['passCode'],
        data() {
            return{
                isOpen: false,
            }
        },
        methods: {
            toggleHandler() {
                this.isOpen = !this.isOpen;
            },
            hideHandler() {
                this.isOpen = false;
            },
            showModal(type) {
                this.$store.dispatch('SHOW_MODAL', {state: true, type: type, data: this.passCode})
                this.hideHandler();
            }
        },
        computed: {
            buttonExtendIsDisabled() {
                let {is_expired, days_remaining} = this.passCode;
                if(!isUndefined(is_expired) && !isUndefined(days_remaining)) {
                    if(is_expired || !days_remaining) return false
                }
                return true
            },
            buttonsList() {

                let list = [];
                let buttonDelete = {
                    title: this.$t('modal.action.Delete.title'),
                    type: "Delete",
                };
                let buttonExtend = {
                    title: this.$t('modal.action.Extend.title'),
                    type: "Extend",
                };
                let buttonApprove = {
                    title: this.$t('modal.action.Approve.title'),
                    type: "Approve",
                }
                let buttonDecline = {
                    title: this.$t('modal.action.Decline.title'),
                    type: "Decline",
                }
                if(!this.passCode.unverified) {
                    list.push(buttonDelete)
                    if(!this.buttonExtendIsDisabled) {
                        list = [buttonExtend, ...list]
                    }
                } else {
                    list = [buttonApprove, buttonDecline]
                }
                return list;

            }
        },
        directives: {
            ClickOutside
        },
    }
</script>


<style lang="sass" scoped>
    .toggle
        width: 24px
        margin: 0 auto
        position: relative
        display: flex
        justify-content: center
        align-items: center
        &.is-active
          .toggle__box
                background: #2F82FF
                border-color: transparent
          .toggle__points
               fill: $color--white
        &__box
            width: 24px
            height: 24px
            background: transparent
            display: flex
            justify-content: center
            align-items: center
            border: 1px solid rgba(1, 37, 78, 0.5)
            transition: background .3s ease, border-color .3s ease
            border-radius: 50%
            cursor: pointer
            &:hover,
            &:active
                background: $color--blue
            &:hover,
            &:active
                border-color: transparent
                .toggle__points
                    fill: $color--white
        &__points
            fill: rgba(1, 37, 78, 0.5)
            +tr(fill .3s ease)
        &__list
            position: absolute
            max-width: 200px
            margin-top: 4px
            background: $color--white
            box-shadow: 0px 2px 10px rgba(11, 35, 75, 0.2)
            border-radius: 4px
            transform-origin: top
            transition: transform .3s ease-in-out
            padding: 8px 12px
            top: 100%
            z-index: 98
            &-item
                cursor: pointer
                +reg
                color: $color--dark
                font-size: 10px
                line-height: 24px
                letter-spacing: 0.0764706px
                &:last-of-type
                    color: $color--red
    .dropdown-enter-active,
    .dropdown-leave-active
        transition: all 0.3s ease

    .dropdown-enter,
    .dropdown-leave-active
        opacity: 0
        will-change: opacity
        transform: translateY(-25px)
</style>